
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import { MediaQueryService } from '../../services/media-query.service';

import './carousel-fullwidth.component.scss';

export class CarouselFullwidth extends Base {

	// carousel
	sliderContainer: Element;
	sliderPagination: Element;
	sliderConfig: SwiperOptions;
	sliderNext: any;
	sliderPrev: any;
	windowWidth: number;
	sliderItems: number;
	breakpoints: {};

	// modals
	modal: any;
	modalLinks: any;
	modalCloseButton: any;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.modal = this.element;
		this.modalLinks = Array.from(document.querySelectorAll('.js-gallery-modal-open'));
		this.modalCloseButton = Array.from(this.element.querySelectorAll('.js-gallery-modal-close'));
	}

	bindEvents() {

		this.modalLinks.map((button)=>button.addEventListener('click', (event)=>{
			
			let elementButton;
			if(event.currentTarget){
				elementButton = event.currentTarget;
			}else{
				elementButton = event.target;
			}

			let modalSelected = elementButton.getAttribute('data-modal');
			let indexSelected = elementButton.getAttribute('data-index');

			if(this.modal.getAttribute('data-modal') === modalSelected){
				this.modal.classList.add('carousel-fullwidth__modal--opened');
				this.initCarousel(indexSelected);
			}

		}))

		this.modalCloseButton.map((button)=>button.addEventListener('click', (event)=>{
			
			let elementButton;
			if(event.currentTarget){
				elementButton = event.currentTarget;
			}else{
				elementButton = event.target;
			}

			this.modal.classList.remove('carousel-fullwidth__modal--opened');

		}))
		
		document.onkeydown = (evt) => {
			evt = evt || window.event;
			let isEscape = false;
			if ("key" in evt) {
				isEscape = (evt.key === "Escape" || evt.key === "Esc");
			} else {
				isEscape = (evt.keyCode === 27);
			}
			if (isEscape) {
				this.modal.classList.remove('carousel-fullwidth__modal--opened');
			}
		};

	}

	initCarousel(initialSlide = 0) {

		this.sliderItems = Number(this.element.getAttribute('data-items'));
		this.sliderContainer = this.element.querySelector('.swiper-container');
		this.sliderPagination = this.element.querySelector('.swiper-pagination');
		this.sliderNext = Array.from(this.element.querySelectorAll('.swiper-button-next'));
		this.sliderPrev = Array.from(this.element.querySelectorAll('.swiper-button-prev'));
		this.windowWidth = document.documentElement.clientWidth;

		switch (this.sliderItems) {
			case 1:
				this.breakpoints = {};
				break;
			case 2:
				this.breakpoints = {
					576: {
						initialSlide: 0,
						slidesPerView: 1,
						spaceBetween: 15,
					}
				};
				break;
			default:
				this.breakpoints = {
					1200: {
						initialSlide: 0,
						slidesPerView: 3,
						spaceBetween: 30,
					},
					768: {
						initialSlide: 0,
						slidesPerView: 2,
						spaceBetween: 20,
					},
					576: {
						initialSlide: 0,
						slidesPerView: 1,
						spaceBetween: 15,
					}
				};
				break;
		}

		this.sliderConfig = {
			slidesPerView: this.sliderItems,
			spaceBetween: 0,
			initialSlide: initialSlide - 1,
			breakpoints: this.breakpoints,
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			pagination: {
				el: this.sliderPagination,
				type: 'bullets',
				clickable: true
			},
			navigation: {
				nextEl: this.sliderNext,
				prevEl: this.sliderPrev,
			}
		};

		Slider.init(this.sliderContainer, this.sliderConfig);

	}

}



// WEBPACK FOOTER //
// ./components/carousel-fullwidth/carousel-fullwidth.component.ts